import React from "react";

import { getOptionValueHash } from "../../../utils/catalogue";
import { notEmpty, unique } from "../../../utils/functional";
import { sortProductOptions } from "../../../utils/sorting";

interface IProps {
    sizeAttributeOptionGroupName: string;
    sizeAttributeOptions: ReadonlyArray<string>;
    priceSelectValue: string;
    onSelectChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

export const SizeSelector = (props: IProps): React.ReactNode => {
    const onSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        props.onSelectChange(e);
    };

    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
    };

    const label = props.sizeAttributeOptionGroupName.replace(" Options", "");
    const cleanedOptions = props.sizeAttributeOptions
        .filter(notEmpty)
        .filter(unique);
    const sortedOptions = sortProductOptions("option_size", cleanedOptions);
    const optionElems = sortedOptions.map((option) => {
        return (
            <option key={getOptionValueHash(option)} value={option}>
                {option}
            </option>
        );
    });
    const selectID =
        props.sizeAttributeOptionGroupName.toLowerCase().replace(" ", "-") +
        "-select";

    return (
        <form onSubmit={onSubmit}>
            <label htmlFor={selectID}>Price by {label}</label>
            <select
                id={selectID}
                className="al-compareresults-selectsize"
                onChange={onSelectChange}
                value={props.priceSelectValue}
            >
                {optionElems}
            </select>
        </form>
    );
};
